import { render, staticRenderFns } from "./CustomTabContainer.vue?vue&type=template&id=48159844&"
import script from "./CustomTabContainer.vue?vue&type=script&lang=ts&"
export * from "./CustomTabContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports